import Color from '../Color.mjs'
import superMeta from '../_MODULE/metaModuleNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GOLD,
    codeProp: 'pmNo',
    mapIdProp: 'bfMapId',
    mapStsCodeProp: 'bfMapStsCode',
    mapTypeCode: 'BF_MAP',
    name: '知识域',
    ownerIdProp: 'paId',
    ownerTextProp: 'paName',
    ownerType: 'PA',
    textProp: 'pmName',
    type: 'PM',
}
